<div class="container">
    <div class="legal-terms-content" [innerHTML]="legalTermsHtml"></div>
</div>
